import LayoutConfigTypes from '@/core/config/LayoutConfigTypes';

const getLogo = () => {
  return {
    dark:
      process.env.VUE_APP_ENV == 'stg'
        ? '/media/logos/hisba_testing_logo.png'
        : '/media/logos/logo-1-dark.png',
    light: '/media/logos/logo-1.svg',
  };
};

const config: LayoutConfigTypes = {
  themeName: 'Metronic',
  themeVersion: '8.0.37',
  demo: 'demo1',
  main: {
    type: 'default',
    primaryColor: '#009EF7',
    logo: getLogo(),
  },
  illustrations: {
    set: 'sketchy-1',
  },
  loader: {
    logo:
      process.env.VUE_APP_ENV == 'stg'
        ? '/media/logos/hisba_testing_logo.png'
        : '/media/logos/logo-1-dark.png',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: false,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: 'dark',
    fixed: true,
    menuIcon: 'svg',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: 'fluid',
  },
  footer: {
    width: 'fluid',
  },
};

export default config;
